import PropTypes from 'prop-types';
export const chevronAlignProptypes = PropTypes.oneOf(['left', 'right', 'none']);